import { render, staticRenderFns } from "./OrderObjects.vue?vue&type=template&id=037deaa6"
import script from "./OrderObjects.vue?vue&type=script&lang=js"
export * from "./OrderObjects.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports